import React from 'react';
import _ from 'underscore';

import {BridgeSiteSettingsCoordinator} from '~src/settings/general-settings/components/bridge-settings/BridgeSiteSettingsCoordinator';
import {subspaceStyle} from '~src/settings/styles/CommonStyles';
import { ISiteBridgeSettingsForSiteAdmin } from '~src/settings/types/ISiteAdminBridgeSettings';

import { SessionManagementService } from '../../../sessionManagement/SessionManagementService';
import { Sites } from '../../../ts/siteManagement/services/resources/Sites';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface BridgeSiteSettingsSubspaceProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
  readonly isSessionServerAdmin: boolean;
}

export interface BridgeSiteSettingsSubspaceState {
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly settings: ISiteBridgeSettingsForSiteAdmin;
}

export class BridgeSiteSettingsSubspace extends React.PureComponent<BridgeSiteSettingsSubspaceProps, BridgeSiteSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: BridgeSiteSettingsSubspaceState = {hasDataToRender: false, settings: undefined, hasError: false};
  private sites = Sites.instance;

  public constructor(props: BridgeSiteSettingsSubspaceProps) {
    super(props);
    this.state = this.initialState;
  }

  public componentDidMount() {
    this.getData();
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate(prevProps: BridgeSiteSettingsSubspaceProps) {
    if (!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.updateState(this.initialState);
      this.getData();
      return;
    }

    if (!_.isUndefined(this.state.settings)) {
        this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      return <RouterError errorType={'default'} urls={this.props.urls} />;
    }

    return (
      <div className={subspaceStyle}>
        <BridgeSiteSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof BridgeSiteSettingsSubspaceState>(newState: Pick<BridgeSiteSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }

  private getData = async () => {
    try {
      await this.props.server.getSessionInfoPromise();
      const settings = await this.sites.getCurrentSiteBridgeSettingsForSiteAdmin();
      this.updateState({settings});
    } catch (e) {
      this.updateState({hasError: true});
    }
  }
}
